export const RECHARGE_TYPE ={
PREPAID_RECHARGE : "PREPAID RECHARGE",
POSTPAID_BILL_PAY : "POSTPAID BILL PAYMENT",
DATA_BUNDLE_PURCHASE : "BUNDLE PURCHASE",
AIRTEL_TV_RECHARGE : "AirtelTV",
BROADBAND_RECHARGE : "Broadband Recharge",
BILL_PAYMENT:"BILL_PAYMENT",
HYBRID_POSTPAID_CHECK:"HYBRID_POSTPAID_CHECK"
}